import { IonBackButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonTitle } from '@ionic/react';
import { arrowBack, checkmarkOutline } from 'ionicons/icons';
import React from 'react';
import IonToolbar from '../../../components/Modal/ModalToolbar';
import './CadastroLayout.css';

type Props = {
  title: string;
  description: string;
  step?: 1 | 2;
  headerTitle?: string;
  eyebrow?: string;
  showHero?: boolean;
  backHref: string;
  icon: string;
  badge: string;
  children: React.ReactNode;
};

const CadastroLayout: React.FC<Props> = ({ title, description, step, headerTitle = 'Criar sua conta', eyebrow = 'COMECE COM O XEGUEI', showHero = true, backHref, icon, badge, children }) => (
  <IonPage className="cadastro-page">
    <IonHeader className="ion-no-border">
      <IonToolbar className="cadastro-toolbar">
        <IonButtons slot="start"><IonBackButton defaultHref={backHref} icon={arrowBack} text="" aria-label="Voltar" /></IonButtons>
        <IonTitle>{headerTitle}</IonTitle>
      </IonToolbar>
    </IonHeader>
    <IonContent className="cadastro-content">
      <main className="cadastro-container">
        {showHero && <section className="cadastro-hero">
          <div>
            <span className="cadastro-eyebrow">{eyebrow}</span>
            <h1>{title}</h1>
            <p>{description}</p>
          </div>
          <span className="cadastro-badge"><IonIcon icon={icon} aria-hidden="true" />{badge}</span>
        </section>}
        {step && <ol className="cadastro-steps" aria-label="Etapas do cadastro">
          <li className={step === 1 ? 'is-current' : 'is-complete'} aria-current={step === 1 ? 'step' : undefined}>
            <span>{step === 1 ? '1' : <IonIcon icon={checkmarkOutline} aria-hidden="true" />}</span>Tipo de conta
          </li>
          <li className={step === 2 ? 'is-current' : ''} aria-current={step === 2 ? 'step' : undefined}><span>2</span>Seus dados</li>
        </ol>}
        {children}
      </main>
    </IonContent>
  </IonPage>
);

export const CadastroSection: React.FC<{ title: string; description?: string; icon: string; children: React.ReactNode }> = ({ title, description, icon, children }) => (
  <section className="cadastro-section">
    <header className="cadastro-section-header">
      <span className="cadastro-section-icon"><IonIcon icon={icon} aria-hidden="true" /></span>
      <div><h2>{title}</h2>{description && <p>{description}</p>}</div>
    </header>
    <div className="cadastro-fields">{children}</div>
  </section>
);

export default CadastroLayout;
